// src/components/BookingContext.js
import React, { createContext, useReducer, useContext } from "react";

// — contexts —
const BookingStateContext = createContext();
const BookingDispatchContext = createContext();

// — initial state: now holds rideType, terminal *and* the details —
const initialState = {
  step: "rideType", // 'rideType' | 'details' | 'review'
  rideType: null,
  terminal: null, // NEW
  terminalLocation: null, // '01' | '02'
  // details fields:
  pickup: "",
  dropOff: "",
  pickupCoordinates: [],
  dropOffCoordinates: [],
  when: "now",
  dateTime: new Date(),
  name: "",
  phone: "",
};

function bookingReducer(state, action) {
  switch (action.type) {
    case "SELECT_RIDE_TYPE":
      return {
        ...state,
        rideType: action.payload,
        step: action.payload === "airport" ? "rideType" : "details",
      };

    // case 'SELECT_TERMINAL':
    //   return {
    //     ...state,
    //     terminal: action.payload,
    //     step:     'details',
    //   }

    case "SELECT_TERMINAL":
      const terminal = action.payload;
      const coords =
        terminal === "01"
          ? { lat: 13.201605323686568, lng: 77.70700442672575 }
          : { lat: 13.199327817300741, lng: 77.71480215307044 };
      return {
        ...state,
        terminal,
        terminalLocation: coords,
        step: "details", // proceed to next step
      };

    // store all the form fields and jump to review
    case "SAVE_DETAILS":
      return {
        ...state,
        ...action.payload,
        // pickup:   action.payload.pickup,
        // dropOff:  action.payload.dropOff,
        // when:     action.payload.when,
        // dateTime: action.payload.dateTime,
        // name:     action.payload.name,
        // phone:    action.payload.phone,
        step: "review",
      };
    case "SET_POSTER_ID":
      return {
        ...state,
        posterId: action.payload,
      };

    case "EDIT_STEP":
      return { ...state, step: action.payload };

    case "TO_CONFIRMATION":
      return { ...state, step: "confirmation" };

    case "SET_FARE_ESTIMATE":
      return {
        ...state,
        fareEstimate: action.payload,
      };

    case "RESET":
      return {
        ...initialState,
        posterId: state.posterId,
      };
    case "SET_PICKUP":
      return {
        ...state,
        pickup: action.payload.placeName,
        pickupCoordinates: action.payload.coords,
      };

    case "SET_DROPOFF":
      return {
        ...state,
        dropOff: action.payload.placeName,
        dropOffCoordinates: action.payload.coords,
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

export function BookingProvider({ children }) {
  const [state, dispatch] = useReducer(bookingReducer, initialState);
  return (
    <BookingStateContext.Provider value={state}>
      <BookingDispatchContext.Provider value={dispatch}>
        {children}
      </BookingDispatchContext.Provider>
    </BookingStateContext.Provider>
  );
}

export function useBookingState() {
  const ctx = useContext(BookingStateContext);
  if (!ctx) throw new Error("useBookingState must be inside BookingProvider");
  return ctx;
}

export function useBookingDispatch() {
  const ctx = useContext(BookingDispatchContext);
  if (!ctx)
    throw new Error("useBookingDispatch must be inside BookingProvider");
  return ctx;
}
